<template>
  <div v-if="!loading">
    <h2>{{ nameTable }}</h2>
    <i
      class="custom__icon"
      :class="open ? 'icon-cerrar' : 'icon-ver_mas02'"
      @click="toggle()"
    ></i>
    <el-form
      @submit.native.prevent="submitAjax(false)"
      ref="form"
      label-position="top"
      id="form"
      v-show="open"
    >
      <el-row type="flex" justify="space-between">
        <el-col v-for="(f, i) in form" :key="i" :span="col(f)">
          <div v-if="f.type == 'image'">
            <input
              type="text"
              class="hidden"
              :id="f.field"
              :name="f.field"
              :value="f.value"
            />
            <app-cropper :options="optionsAjax"></app-cropper>
          </div>
          <app-item-form v-else :f="f"></app-item-form>
        </el-col>
      </el-row>

      <el-form-item v-if="!loading">
        <button type="submit" class="el-button el-button--primary">
          <span>{{ btn }}</span>
        </button>
      </el-form-item>
      <template v-if="multiple">
        <div class="loading" v-loading="loading" v-if="loading"></div>
        <template v-else>
          <app-table-paginate
            :tableQuery="datos"
            :tableColumns="headers"
            :search="false"
            :editAjax="edit"
            :table="table"
          ></app-table-paginate>
        </template>
      </template>
    </el-form>

    <el-dialog
      title="Selecciona un tipo de plantilla"
      :visible.sync="editRegister"
      v-if="edit"
    >
      <el-form @submit.native.prevent="submitAjax(true)" ref="form" label-position="top">
        <el-row type="flex" justify="space-between">
          <el-col v-for="(f, i) in formEditAjax" :key="i" :span="col(f)">
            <div v-if="f.type == 'image'">
              <input
                type="text"
                class="hidden"
                :id="f.field"
                :name="f.field"
                :value="f.value"
              />
              <app-cropper :options="optionsAjax"></app-cropper>
            </div>
            <app-item-form v-else :f="f"></app-item-form>
          </el-col>
        </el-row>
        <el-form-item v-if="!loading">
          <button type="submit" class="el-button el-button--primary">
            <span>{{ btn }}</span>
          </button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import { API_UPLOADS } from "@/common/config";
import { mapGetters } from "vuex";
import itemForm from "@/components/Dashboard/forms/itemForm";
import sha1 from "sha1";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import moment from "moment-timezone";
import Cropper from "@/components/Dashboard/commons/cropper2";

export default {
  name: "formajax",
  props: ["table", "template", "multiple", "row", "edit"],
  components: {
    "app-item-form": itemForm,
    "app-table-paginate": tablaConPaginador,
    "app-cropper": Cropper,
  },
  computed: {
    ...mapGetters(["getSidebar"]),
  },
  created() {
    setTimeout(() => {
      this.getSidebar.filter((s) => {
        if (this.table == s.name_table) {
          this.nameTable = s.display_name_plural;
        }
      });
    }, 1000);

    this.multiple ? (this.btn = "Añadir") : (this.btn = "Actualizar");
    this.$root.$on("imagenCargada", (file) => (this.file = file));
    this.$root.$on("imagenEliminada", () => (this.file = false));
    this.$root.$on("load-doc", (doc, field) => {
      this.documentos_subidos.push({ doc, field });
      //this.doc = doc;
    });
    this.$root.$on("delete", (id) => {
      if (this.table == id.table) {
        this.loading = true;
        this.eliminarRegistro(id.row);
      }
    });
    this.$root.$on("editAjax", (row) => this.editarRegistro(row));

    this.initApi();
  },
  beforeDestroy() {
    this.$root.$off("imagenCargada", (file) => (this.file = file));
    this.$root.$off("delete", (id) => {
      this.eliminarRegistro(id);
    });
    this.$root.$off("imagenEliminada", () => (this.file = false));
    this.$root.$off("load-doc", (doc, field) => {
      this.documentos_subidos.push({ doc, field });
      //this.doc = doc;
    });
    this.$root.$off("delete", (id) => {
      if (this.table == id.table) {
        this.loading = true;
        this.eliminarRegistro(id.row);
      }
    });
    this.$root.$off("editAjax", (row) => this.editarRegistro(row));
  },
  data() {
    return {
      documentos_subidos: [],
      loading: true,
      id: this.$route.params.id,
      btn: "",
      nameTable: "",
      form: [],
      formEdit: [],
      formEditAjax: [],
      field: {},
      datos: [],
      headers: [],
      relationship: [],
      tableInfo: null,
      optionsAjax: {
        img: null,
        size: 1,
        outputType: "jpg",
        canMove: true,
        canMoveBox: false,
        class: "cropper-medium",
        info: true,
        canScale: true,
        autoCrop: true,
        autoCropHeight: 500,
        autoCropWidth: 500,
        fixed: false,
        fixedBox: true,
        centerBox: true,
        fixedNumber: [500, 500],
        ref: "cropper-ajax",
      },
      document: null,
      doc: false,
      image: false,
      file: false,
      routeEdit: false,
      open: true,
      editRegister: false,
      editAjaxId: false,
    };
  },
  methods: {
    async initApi() {
      await this.getEditTable();
      await this.mountTable();
    },
    async getEditTable() {
      const response = await ApiService.post("dashboard/getbread", {
        table: this.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
      });
      if (response) {
        this.field = response.data.data;
      }
    },
    async getListTable() {
      let data;
      this.datos = [];
      if (this.template) {
        data = {
          table: this.table,
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          template: this.template,
          row: this.row,
          id: this.id,
        };
      } else {
        data = {
          table: this.table,
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          row: this.row,
          id: this.id,
        };
      }
      const response = await ApiService.post("dashboard/table", data);

      if (response.data != "Algo ha fallado") {
        if (this.template) {
          const r = await ApiService.post("dashboard/table", {
            table: "sections_contents",
            token: localStorage.getItem("token"),
            project_id: localStorage.getItem("table"),
            row: "content_id",
            id: response.data[0].id,
          });
          this.id = r.data[0].id;
          if (this.multiple) {
            this.datos = response.data;
          } else {
            this.datos = response.data[0];
          }
          this.datos.sections_contents = r.data[0].section_id;
        } else {
          this.multiple ? (this.datos = response.data) : (this.datos = response.data);
        }
      }
      setTimeout(() => {
        this.headers.forEach((element, i) => {
          if (element.options.length > 0) {
            this.datos.filter((e) => {
              let b;
              element.options.filter((o) => {
                if (o.id == e[element.prop]) {
                  let a = "";
                  this.relationship[0].relationship.options.map((h) => {
                    a = a + o[h.key] + " ";
                  });
                  b = a;
                }
              });
              e[element.prop] = b;
            });
          }
          this.form.push({
            type: element.type,
            field: element.path,
            name: element.name,
            label: element.title,
            value: this.datos[element.path],
            key: element.key,
            options: element.options,
          });
        });
      }, 500);

      setTimeout(() => {
        this.loading = false;
      }, 500);
    },

    async getOptionsSelect(data, e) {
      const response = await ApiService.post("dashboard/selectoptions", {
        table: this.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        header: this.headers,
        relationship: data,
      });
      // si estoy en la seccion de mover subseccion, muestro la pagina de donde viene
      if (typeof data.relationship.table != "undefined") {
        if (data.relationship.table == "sections") {
          const r = await ApiService.post("dashboard/sections-page", {
            table: "sections_contents",
            token: localStorage.getItem("token"),
            project_id: localStorage.getItem("table"),
            row: "content_id",
            id: response.data[0].id,
          });
          var secciones = r.data;
          secciones.forEach(function (part, index, theArray) {
            let title = secciones[index]["title"];
            let pagina = secciones[index]["pagina"];

            secciones[index]["title"] = pagina + "/";
            secciones[index]["pagina"] = title;
          });

          secciones.sort((a, b) => (a.title > b.title ? 1 : b.title > a.title ? -1 : 0));

          response.data = secciones;
        } else if (data.relationship.table == "listados") {
          const r = await ApiService.post("dashboard/get-listados", {
            table: "listados",
            token: localStorage.getItem("token"),
            project_id: localStorage.getItem("table"),
            row: "content_id",
            id: response.data[0].id,
          });

          response.data = r.data;
        }
        console.log(response.data);
      }

      this.headers.push({
        title: e.name,
        path: e.field,
        type: e.type,
        key: data.relationship.options[0].key,
        options: response.data,
        label: e.name,
        prop: e.field,
      });
    },
    async mountTable() {
      let relationship = [this.table];

      await this.field.forEach((e, i) => {
        if (i != 0) {
          if (e.visibility["edit"]) {
            if (e.options.length > 0) {
              for (let index = 0; index < e.options.length; index++) {
                if (e.options[index].relationship) {
                  let data = { relationship: e.options[index].relationship };
                  this.relationship.push(data);
                  this.getOptionsSelect(data, e);
                }
              }
            } else {
              this.headers.push({
                title: e.name,
                path: e.field,
                type: e.type,
                key: false,
                options: e.options,
                label: e.name,
                prop: e.field,
              });
            }
          }
        }
      });
      this.getListTable();
    },
    col(v) {
      switch (v.type) {
        case "texto_enriquecido":
          return 24;
          break;
        case "file":
          this.document = {
            field: v.field,
            value: v.value,
          };
          return 11;
          break;
        case "image":
          this.image = {
            field: v.field,
            value: v.value,
          };
          this.optionsAjax.img = API_UPLOADS + v.value;
          return 24;
          break;
        default:
          return 11;
          break;
      }
    },
    async submitAjax(a = false) {
      a ? this.editAjax(this.formEditAjax) : this.saveAjax(this.form);
    },
    async saveAjax(form) {
      if (this.file != false) {
        let file = new FormData();
        file.append("file", this.file);
        const response = await ApiService.post("upload/contenido", file);
        this.image.value = response.data;
        let a = form.filter((form) => {
          if (form.field == this.image.field) {
            form.value = this.image.value;
          }
        });
      }
      /* if (this.doc && this.doc[0].size) {
        let data = new FormData();
        data.append("file", this.doc[0].raw);
        const response = await ApiService.post("upload/contenido", data);
        this.document.value = response.data;
        let a = form.filter(form => {
          if (form.field == this.document.field) {
            form.value = this.document.value;
          }
        });
      } */

      if (this.documentos_subidos.length > 0) {
        for (const i of this.documentos_subidos) {
          console.log(i);
          if (i.doc[0].size) {
            console.log(i);
            let data = new FormData();
            data.append("file", i.doc[0].raw);
            data.append("type", "file");
            data.append("domain", localStorage.getItem("project"));
            let documento = await this.uploadFile(data);
            this.form.filter((form) => {
              if (form.field == i.field) {
                form.value = documento;
              }
            });
          }
        }
      }

      let formEdit = this.form.map((form) => {
        let a;
        if (form.field == "pass") {
          a = {
            field: form.field,
            value: sha1(form.value),
          };
        } else if (form.field == "id") {
          this.id = form.value;
        } else {
          if (form.type == "date") {
            form.value
              ? (form.value = moment(form.value).tz("Europe/Madrid").format("YYYY-MM-DD"))
              : false;
          }
          a = {
            field: form.field,
            value: form.value,
            type: form.type,
          };
        }
        return a;
      });

      let data = {
        table: this.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
      };
      if (this.table == "access") {
        (data.id = this.id), (data.row = "user_id");
      } else if (this.template) {
        data.id = this.id;
        data.table = "sections_contents";
        formEdit = [
          {
            field: "section_id",
            value: this.form[0].value,
          },
        ];
      } else if (!this.multiple) {
        data.id = this.id;
      } else {
        formEdit.push({
          field: this.row,
          value: this.id,
        });
      }
      data.form = formEdit;

      const response = await ApiService.post("dashboard/editformdinamic", data);
      if (response.data != "Algo ha fallado") {
        this.loading = true;
        this.form = [];
        this.getListTable();
        this.$notify({
          title: "Modificado",
          message: "Se ha añadido la entrada con éxito",
          type: "success",
        });
      } else {
        this.$notify.error({
          title: "Fallo",
          message: "Ago ha fallado y no se ha podido añadir la entrada",
        });
      }
    },
    async uploadFile(data) {
      const response = await ApiService.post("upload/contenido", data);
      return response.data;
    },
    async editAjax(form) {
      if (this.image != false) {
        if (this.file != false) {
          let file = new FormData();
          file.append("file", this.file);
          ApiService.post("upload/contenido", file).then((response) => {
            this.image.value = response.data;
            let a = this.form.filter((form) => {
              if (form.field == this.image.field) {
                form.value = this.image.value;
              }
            });
          });
        }
      }
      /* if (this.doc && this.doc[0].size) {
        let data = new FormData();
        data.append("file", this.doc[0].raw);
        ApiService.post("upload/contenido", data).then(response => {
          this.document.value = response.data;
          let a = this.form.filter(form => {
            if (form.field == this.document.field) {
              form.value = this.document.value;
            }
          });
        });
      } */
      if (this.documentos_subidos.length > 0) {
        for (const i of this.documentos_subidos) {
          console.log(i);
          if (i.doc[0].size) {
            console.log(i);
            let data = new FormData();
            data.append("file", i.doc[0].raw);
            data.append("type", "file");
            data.append("domain", localStorage.getItem("project"));
            let documento = await this.uploadFile(data);
            this.form.filter((form) => {
              if (form.field == i.field) {
                form.value = documento;
              }
            });
          }
        }
      }

      setTimeout(() => {
        let pivot = [];
        this.formEdit = form.map((form) => {
          if (!this.id && form.pivot && form.value.length > 0) {
            pivot.push({ pivot: form.pivot[0], val: form.value });
          } else {
            if (form.type == "date") {
              form.value
                ? (form.value = moment(form.value)
                    .tz("Europe/Madrid")
                    .format("YYYY-MM-DD"))
                : false;
            }

            if (form.value === false) {
              // para que funcione el switch
              //form.value = "2";
            }
            return {
              field: form.field,
              value: form.value,
              type: form.type,
            };
          }
        });
        ApiService.post("dashboard/editformdinamic", {
          table: this.table,
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          id: this.editAjaxId,
          form: this.formEdit,
        }).then((response) => {
          if (response.data != "Algo ha fallado") {
            let title, message;
            this.id ? (title = "Registro modificado") : (title = "Registro creado");
            this.id
              ? (message = "Se ha modifcado la entrada con éxito")
              : (message = "Se ha creado la entrada con éxito");

            if (pivot.length > 0) {
              pivot.filter((p) => {
                let form = Object.create({});
                form[p.pivot.keys[0][1]] = parseInt(response.data);
                p.val.filter((v) => {
                  setTimeout(() => {
                    form[p.pivot.keys[0][2]] = v;
                    ApiService.post("dashboard/editform", {
                      table: p.pivot.table,
                      token: localStorage.getItem("token"),
                      project_id: localStorage.getItem("table"),
                      form: form,
                    });
                  }, 300);
                });
              });
            }
            this.$notify({
              title: title,
              message: message,
              type: "success",
            });
            this.editRegister = !this.editRegister;
            this.loading = !this.loading;
            this.form = [];
            this.formEditAjax = [];
            this.getListTable();
          } else {
            this.$notify.error({
              title: "Fallo",
              message: "Ago ha fallado y no se ha modificado la entrada",
            });
          }
        });
      }, 1000);
    },
    async editarRegistro(row) {
      console.log("editarregistro", row);
      const response = await ApiService.post("dashboard/table", {
        table: this.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: row.id,
      });

      this.editAjaxId = response.data.id;
      this.formEditAjax = this.form.map((f) => {
        f.value = response.data[f.field];
        return f;
      });
      this.editRegister = !this.editRegister;
    },
    async eliminarRegistro(id) {
      this.loading = true;
      this.form = [];
      const response = await ApiService.post("dashboard/delete", {
        table: this.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: id,
      });
      if (response) {
        this.deleterow = response.data;
        if (this.deleterow == 1) {
          this.$message({
            type: "success",
            message: "Se ha eliminado correctamente",
          });
          setTimeout(() => {
            this.loading = true;
            this.form = [];
            this.getListTable();
          }, 200);
        } else {
          this.$message({
            type: "warning",
            message: this.deleterow,
          });
        }
      }
    },
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>

<style>
.el-select {
  width: 100%;
}
.el-row {
  flex-flow: row wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/forms/formajax.vue